import LegalDocumentPage from '../components/legal/LegalDocumentPage.jsx'

const sections = [
  {
    title: 'Données collectées',
    paragraphs: [
      'Dans le cadre de l’utilisation de la plateforme USTS, nous pouvons collecter des données nécessaires au fonctionnement du service et à l’authentification des utilisateurs.',
      'Les données peuvent inclure notamment les informations de compte Google, les coordonnées professionnelles, les contenus saisis par l’utilisateur et les traces techniques nécessaires au bon fonctionnement du service.',
    ],
  },
  {
    title: 'Finalités du traitement',
    paragraphs: [
      'Les données sont traitées afin de fournir l’accès au service, d’assurer la gestion des comptes, de sécuriser la plateforme et d’améliorer l’expérience utilisateur.',
    ],
    bullets: [
      'Authentification et gestion des comptes.',
      'Fourniture des fonctionnalités de la plateforme.',
      'Support utilisateur et assistance technique.',
      'Sécurité, prévention de la fraude et journalisation technique.',
    ],
  },
  {
    title: 'Base légale',
    paragraphs: [
      'Les traitements reposent selon les cas sur l’exécution du contrat, l’intérêt légitime de l’éditeur à sécuriser et améliorer le service, ou le consentement de l’utilisateur lorsque celui-ci est requis.',
    ],
  },
  {
    title: 'Durée de conservation',
    paragraphs: [
      'Les données sont conservées pendant la durée nécessaire à la fourniture du service, puis archivées ou supprimées conformément aux obligations légales et aux besoins opérationnels.',
      'Les durées précises peuvent varier selon la nature des données et les obligations applicables.',
    ],
  },
  {
    title: 'Destinataires et sous-traitants',
    paragraphs: [
      'Les données peuvent être accessibles aux équipes habilitées d’USTS et à certains prestataires techniques strictement nécessaires au fonctionnement du service.',
      'Lorsque des sous-traitants sont utilisés, ils agissent uniquement sur instruction d’USTS et dans le respect des règles de confidentialité et de sécurité applicables.',
    ],
  },
  {
    title: 'Droits des utilisateurs',
    paragraphs: [
      'Conformément à la réglementation applicable, les utilisateurs disposent de droits d’accès, de rectification, d’effacement, de limitation, d’opposition et, lorsque cela s’applique, de portabilité.',
      'Ils peuvent également retirer leur consentement lorsqu’un traitement repose sur cette base légale.',
    ],
    note: 'Pour exercer vos droits, contactez-nous à l’adresse indiquée en bas de page.',
  },
  {
    title: 'Cookies et traceurs',
    paragraphs: [
      'La plateforme peut utiliser des cookies ou traceurs techniques nécessaires à l’authentification, à la sécurité et au bon fonctionnement du service.',
      'Des traceurs de mesure d’audience ou d’amélioration produit peuvent également être activés selon les réglages du site.',
    ],
  },
]

export default function PrivacyPolicy() {
  return (
    <LegalDocumentPage
      title="Politique de confidentialité"
      subtitle="Information sur la collecte et l’utilisation des données personnelles"
      lastUpdated="02 avril 2026"
      intro="Cette page présente les principes de traitement des données personnelles pour la plateforme USTS. Elle peut être utilisée comme page de référence dans Google Cloud Console."
      sections={sections}
      contactEmail="privacy@usts.ai"
      contactLabel="Questions sur la confidentialité"
      contactDescription="Pour toute question liée à la protection des données et à la vie privée, écrivez-nous à l’adresse suivante."
    />
  )
}
